import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import StaleOfflineCleanupSettings from '../../../components/ParametersPage/StaleOfflineCleanup';
import UserAgentUtils from '../../../utils/userAgent';
import { isStaleOfflineCleanupEnabled } from '../../../utils/staleOfflineCleanupConfig';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos: { config },
		staleOfflineCleanup: { autoCleanEnabled, preferencesLoaded },
	} = state;

	return {
		autoCleanEnabled,
		isVisible: UserAgentUtils.isMobileApp
			&& preferencesLoaded
			&& isStaleOfflineCleanupEnabled(config),
	};
};

export default connect(mapStateToProps)(StaleOfflineCleanupSettings);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/StaleOfflineCleanup/index.tsx